import { useParams } from 'next/navigation'
import { useTaskToolContext } from '@/app/providers/task-tool-context/task-tool-context-provider'

export default function useGetProjectIdWithContext() {
  const context = useTaskToolContext()
  const params = useParams<{ projectId: string }>()

  if (context) {
    return { projectId: context.projectId }
  }
  if (!params?.projectId) return { projectId: '' }
  return params
}
